import { Injectable } from '@angular/core';
import { MiraieService } from './miraie.service';

@Injectable({
  providedIn: 'root'
})
export class AnalysisService {

  constructor(
    private http: MiraieService,
  ) { }


  /**
   * 区分ごとのコード取得
   * @param code_kbn 
   * 1:ステータス　2:ステータス(みらい財団) 3:ランク 4:OBランク 5:土地ポイント
   * 6:資金ポイント 7:プランポイント 8:競合ポイント 9:影響者ポイント 10:時期ポイント
   * 11:見学ポイント 12:運営事業者ポイント 13:申込ポイント 14:敗因項目　15:追加アポなし原因
   * 16:申込アポなし原因 17:性別 18:イベントタイプ 19:ユーザ別イベントタイプ 20:アンケート選択項目タイプ
   */
  getCodeAnalysis(code_kbn) {
    var url = "analysis/code";
    let param = { code_kbn }
    return this.http.post(url, param );
  }

  //失注原因リスト
  getLostAnalysis(year) {
    var url = "analysis/lost";
    let param = { year }

    return this.http.post(url, param );
  }

  
  /**
   * 入金リスト
   * @param start 検索開始日
   * @param end   検索終了日
   */
  getSalesSummary(start, end) {
    var url = "analysis/summary";
    let param = { start, end }

    return this.http.post(url, param );
  }

  //契約進捗リスト'(きっかけ別)
  getContractList(year, quarter, division_code) {
    var url = "analysis/contract"
    let param = { year, quarter, division_code }

    return this.http.post(url, param );
  }

  //契約進捗リスト(ユーザー別)
  getUserContractList(year, quarter, division_code) {
    var url = "analysis/user-contract"
    let param = { year, quarter, division_code }

    return this.http.post(url, param );
  }

  //四半期売上
  getQuarter(year, quarter, division_code) {
    var url = "analysis/quarter"
    let param = { year, quarter, division_code }

    return this.http.post(url, param );
  }

  // 面談集計
  getInterviewList(year, month) {
    var url = "analysis/interview"
    let param = { year, month }

    return this.http.post(url, param );
  }
}
